import { tns } from 'tiny-slider/src/tiny-slider'


export default () => {

	const els = [...document.querySelectorAll('.hero')]
	els.map(el => {

		const carouselEl = el.querySelector('.hero__cont')
		if (!carouselEl) return null

		const carouselNav = el.querySelector('.hero__dots')


		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			controls : false,
			controlsPosition: 'bottom',
			nav: true,
			navContainer: carouselNav,
			touch: true,
			mouseDrag: true,
			loop: true,
			autoplay: true,
			speed: 700,
			autoplayTimeout: 7000,
			autoplayButtonOutput: false,		
		})
	})
}


